import { MDBBadge, MDBCol, MDBContainer, MDBIcon, MDBRow, } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../Pages/Accueil/Accueil.css";
import { useDarkMode } from "../../components/assets/DarkModeContext";
import { useCurrentUser } from "../../components/hooks/useCurrentUser";
import OriginalResumePdfPreview from "../../components/resume-list/OriginalResumePdfPreview";
import ResumeList from "../../components/resume-list/ResumeList";
import { getProfile, getUserWithResumesById, } from "../../components/services/httpService";
import { Evaluation } from "../../components/user/Evaluation";
import Information from "../../components/user/Information";
import { formatPrenom } from "../../utils/formatPrenom";

export default function MonCompte() {
    const [user, setUser] = useState({ nom: "", role: "", email: "", docUrl: "" });
    const [userResumes, setUserResumes] = useState([]);
    const [activeTab, setActiveTab] = useState("Mes CVS");
    const currentUser = useCurrentUser();
    const { isDarkMode } = useDarkMode();

    useEffect(() => {
        getProfile()
            .then((response) => response.json())
            .then((data) => {
                getUserWithResumesById(data.id)
                    .then((r) => {
                        return r.json();
                    })
                    .then((d) => {
                        const { resumes, ...userData } = d;
                        setUser(userData);
                        if (Array.isArray(resumes)) {
                            setUserResumes(resumes);
                        } else {
                            console.error("Data received is not an array", resumes);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });

            })
            .catch((error) => console.error(error));
    }, []);

    useEffect(() => {
        if (currentUser && currentUser.role === "CLIENT") {
            setActiveTab("Information");
        }
    }, [currentUser]);

    const sortedResumes = [...userResumes].sort((a, b) => {
        const dateA = a.lastModificationDate
            ? new Date(a.lastModificationDate)
            : new Date(0);
        const dateB = b.lastModificationDate
            ? new Date(b.lastModificationDate)
            : new Date(0);

        return dateB - dateA;
    });

    const refresh = () => {
        getProfile()
            .then((response) => response.json())
            .then((data) => {
                getUserWithResumesById(data.id)
                    .then((r) => {
                        return r.json();
                    })
                    .then((d) => {
                        const { resumes, ...userData } = d;
                        setUser(userData);
                        if (Array.isArray(resumes)) {
                            setUserResumes(resumes);
                        } else {
                            console.error("Data received is not an array", resumes);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });

            })
            .catch((error) => console.error(error));
    }

    return (
        <MDBContainer fluid className={isDarkMode ? "bg-dark-mode" : "bg-light"}>
            <MDBContainer className="pb-5">
                <section className="text-center text-md-start bg-nav animation-fade-in">
                    <div
                        className="p-5 bg-image"
                        style={{
                            height: "300px",
                            backgroundImage: 'url("./bg/creation-cv.jpg")',
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundAttachment: "fixed",
                        }}
                    ></div>
                    <div
                        className="pb-2"
                        style={{ backgroundColor: "background-color: hsl(0, 0%, 98%)" }}
                    >
                        <MDBContainer>
                            <MDBRow className="d-flex justify-content-center align-items-center">
                                <MDBCol lg="7" md="7" className="mb-4 mb-md-0 pt-4">
                                    <div className="image-container">
                                        <img
                                            src="./spinner-alcyone.png"
                                            className="rounded-circle float-none float-md-start me-4 mb-3 bg-white"
                                            alt=""
                                            style={{
                                                width: "168px",
                                                marginTop: "-80px",
                                                border: "4px solid hsl(0, 0%, 98%)",
                                                position: "relative",
                                                zIndex: 1000,
                                            }}
                                        />
                                    </div>
                                    <h1 className={isDarkMode ? "text-white" : "text-muted"}>
                                        {user && user.prenom ? formatPrenom(user.prenom) : ""}{" "}
                                        <span className="text-uppercase">
                                            {user && user.nom ? user.nom : ""}
                                        </span>
                                    </h1>
                                    <h2 style={{ color: "#09B4BF" }}>{user.role === "SUPERADMIN" ? "SUPER ADMIN"
                                        : user.role}</h2>
                                </MDBCol>
                                <MDBCol
                                    lg="5"
                                    md="5"
                                    className="mb-4 mb-md-0 text-center text-lg-end"
                                >
                                    {user && user.manager && (
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="d-flex flex-column">
                                                {" "}
                                                <h3
                                                    className={
                                                        isDarkMode
                                                            ? "text-white"
                                                            : "text-muted d-flex align-items-center"
                                                    }
                                                >
                                                    {" "}
                                                    {formatPrenom(user.manager.prenom)}
                                                    <span className="text-uppercase ms-2">
                                                        {user.manager.nom}
                                                    </span>
                                                </h3>
                                                <span style={{ color: "#09B4BF" }}>
                                                    {user.manager?.managerDetails?.poste}
                                                </span>
                                            </div>
                                            <div className="image-container mt-3 ms-3">
                                                <img
                                                    src="./spinner-alcyone.png"
                                                    className="rounded-circle float-none float-md-start me-4 mb-3 bg-white"
                                                    alt=""
                                                    style={{
                                                        width: "112px",
                                                        border: "4px solid hsl(0, 0%, 98%)",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {user.role === "SUPERADMIN" && (
                                        <Link to="/super-admin">
                                            <MDBBadge className="mx-2" color="info" light>
                                                Espace Super Admin
                                            </MDBBadge>
                                            <MDBIcon
                                                fas
                                                icon="user-secret"
                                                size="3x"
                                                style={{ color: "#09B4BF" }}
                                                className=""
                                            />
                                            <MDBBadge color="danger" dot />
                                        </Link>
                                    )}
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </div>
                </section>

                <MDBContainer className="mt-5">
                    <div>
                        <ul
                            className="nav nav-tabs mb-5 justify-content-center"
                            id="issuesTabs"
                            role="tablist"
                        >
                            {user.role !== "CLIENT" && (
                                <li className="nav-item" role="Mes CVS">
                                    <button
                                        className={`nav-link ${activeTab === "Mes CVS" ? "active" : ""
                                            } ${isDarkMode ? "text-white bg-dark-mode" : ""}`}
                                        id="tab-3"
                                        onClick={() => setActiveTab("Mes CVS")}
                                    >
                                        Mes CVs
                                    </button>
                                </li>
                            )}
                            {user.role !== "CLIENT" && (
                                <li className="nav-item" role="cvOrigine">
                                    <button
                                        className={`nav-link ${activeTab === "cvOrigine" ? "active" : ""
                                            } ${isDarkMode ? "text-white bg-dark-mode" : ""}`}
                                        id="tab-2"
                                        onClick={() => setActiveTab("cvOrigine")}
                                    >
                                        CV d'origine
                                    </button>
                                </li>
                            )}
                            {user.role !== "CLIENT" && (
                                <li className="nav-item" role="Evaluation">
                                    <button
                                        className={`nav-link ${activeTab === "Evaluation" ? "active" : ""
                                            } ${isDarkMode ? "text-white bg-dark-mode" : ""}`}
                                        id="tab-1"
                                        onClick={() => setActiveTab("Evaluation")}
                                    >
                                        Evaluation des performances
                                    </button>
                                </li>
                            )}
                            <li className="nav-item" role="Information">
                                <button
                                    className={`nav-link ${activeTab === "Information" ? "active" : ""
                                        } ${isDarkMode ? "text-white bg-dark-mode" : ""}`}
                                    id="tab-1"
                                    onClick={() => setActiveTab("Information")}
                                >
                                    Mes Informations
                                </button>
                            </li>
                        </ul>
                    </div>
                    {user.role !== "CLIENT" && activeTab === "Mes CVS" && (
                        <ResumeList
                            title={'Mes CVs'}
                            resumes={sortedResumes}
                            user={user}
                            refresh={refresh}
                        />
                    )}
                    {user.role !== "CLIENT" && activeTab === "cvOrigine" && (
                        <OriginalResumePdfPreview
                            currentUser={currentUser}
                            user={user}
                        />
                    )}
                    {user.role !== "CLIENT" && activeTab === "Evaluation" && (
                        <Evaluation />
                    )}
                    {activeTab === "Information" && (
                        <Information userData={user} authenticatedUserRole={currentUser.role} />
                    )}
                </MDBContainer>
            </MDBContainer>
        </MDBContainer>
    );
}
